import React from "react";
import obj from "../../utils/constants";
import { Link } from "react-router-dom";
import expandarrow from "../../assets/images/expand-arrow.png";
export const FancyListDropdown = ({
  showMatch,
  data,
  selectData,
  fancyOdds,
  res,
  title,
  fancyOddsOld,
}) => {
  return (
    showMatch && (
      <tr key={data[0]?.runnerName}>
        {/* <td>{data[0]?.runnerName}</td> */}
        {/* <td className="back-3 p-0" style={{ cursor: "not-allowed" }}>
          <div className="light-blue rounded-0">
            <strong>
              {fancyOdds && fancyOdds.length > 0 && fancyOdds[0]?.rt
                ? fancyOdds[0]?.rt
                : "--"}
            </strong>
            <span className="d-block">
              {fancyOdds && fancyOdds.length > 0 && fancyOdds[0]?.pt
                ? fancyOdds[0]?.pt
                : "--"}
            </span>
          </div>
        </td>
        
        <td className="lay-2 p-0" style={{ cursor: "not-allowed" }}>
          <div className="dark-pink rounded-0">
            <strong>
              {fancyOdds && fancyOdds.length > 0 && fancyOdds[1]?.rt
                ? fancyOdds[1]?.rt
                : "--"}
            </strong>
            <span className="d-block">
              {fancyOdds && fancyOdds.length > 0 && fancyOdds[1]?.pt
                ? fancyOdds[1]?.pt
                : "--"}
            </span>
          </div>
        </td>

        <td width="80" className="border-l">
          <Link
            to={`/ViewBets/${res?.eventId}/${res?.matchName}/${title}/${
              obj.betCheckObjNew[res?.gameType]
            }/${res?.selectionId}`}
            target="_blank"
            className="view-btn"
          >
            View
          </Link>
        </td> */}
        <td colspan="3" class="back-3 p-0">
          <div class="for-agent">
            <img src={expandarrow} className="fancy-expand-arrow"></img>
            <div id="fancyBetTable" class="bets-wrap fancy_bet">
              <div id="fancyBetHead" class="fancy-head">
                <h4>
                  <span>Fancy Bet</span>
                </h4>
              </div>

              <table
                id="fancyBetMarketList"
                class="bets"
                style={{ width: `100%` }}
              >
                <tbody>
                  <tr class="bet-all">
                    <th colspan="2"></th>
                    {/* <td colspan="2"></td> */}
                    <td>
                      <span className="d-flex justify-content-center align-items-center">
                        No{" "}
                      </span>
                    </td>
                    <td>
                      {" "}
                      <span className="d-flex justify-content-center align-items-center">
                        Yes
                      </span>
                    </td>
                    <td class="refer-book" style={{ width: "15%" }}></td>
                  </tr>
                </tbody>
                <tbody id="content">
                  <tr id="fancyBetMarket_2182235">
                    <th colSpan={2} style={{ padding: "0 5px" }}>
                      <dl class="fancy-th-layout mb-0">
                        <dt>
                          <p className="mb-0" id="marketName">
                            {data[0]?.fancyName}
                          </p>
                        </dt>
                        <dd class="dd-tips">
                          <ul class="fancy-tips"></ul>
                        </dd>
                      </dl>
                    </th>
                    <td colspan="2" class="multi_select p-0" id="multi_select">
                      <ul>
                        <li
                          class={`lay-1 ${
                            fancyOdds.length > 0 &&
                            fancyOdds[0]?.rt != fancyOddsOld.length > 0 &&
                            fancyOddsOld[0]?.rt
                              ? "back-lay"
                              : ""
                          } `}
                          id="lay_1"
                        >
                          <a
                            style={{ fontWeight: "600" }}
                            id="runsInfo"
                            className="d-flex flex-column align-items-center"
                          >
                            {fancyOdds &&
                            fancyOdds.length > 0 &&
                            fancyOdds[0]?.rt
                              ? fancyOdds[0]?.rt
                              : "--"}
                            <span style={{ fontSize: "10px" }}>
                              {fancyOdds &&
                              fancyOdds.length > 0 &&
                              fancyOdds[0]?.pt
                                ? fancyOdds[0]?.pt
                                : "--"}
                            </span>
                          </a>
                        </li>

                        <li class={`back-1 ${
                            fancyOdds.length > 0 &&
                            fancyOdds[1]?.rt != fancyOddsOld.length > 0 &&
                            fancyOddsOld[1]?.rt
                              ? "lay-spark"
                              : ""
                          }`} id="back_1">
                          <a
                            className="d-flex flex-column align-items-center"
                            style={{ fontWeight: "600" }}
                            id="runsInfo"
                          >
                            {" "}
                            {fancyOdds &&
                            fancyOdds.length > 0 &&
                            fancyOdds[1]?.rt
                              ? fancyOdds[1]?.rt
                              : "--"}
                            <span style={{ fontSize: "10px" }}>
                              {fancyOdds &&
                              fancyOdds.length > 0 &&
                              fancyOdds[1]?.pt
                                ? fancyOdds[1]?.pt
                                : "--"}
                            </span>
                          </a>
                        </li>
                      </ul>
                    </td>
                    <td
                      class="td-fancy_merge"
                      style={{ padding: "0 5px", marginBottom: "0" }}
                    >
                      <dl style={{ marginTop: "6px" }} class="fancy-info">
                        <dt
                          style={{
                            fontSize: "10px",
                            color: "#7e97a7",
                            fontWeight: "normal",
                            margin: "0",
                            lineHeight: "10px",
                          }}
                        >
                          Min/Max
                        </dt>
                        <dd
                          style={{
                            fontSize: "10px",
                            fontWeight: "normal",
                            margin: "0",
                          }}
                          id="minMax"
                        >
                          {" "}
                          5.00 / 5,491.00
                        </dd>
                      </dl>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </td>
        <td style={{ background: `#e2e8ed` }}></td>
      </tr>
    )
  );
};
